/* globals $,donationForm */

/*
 * Donation form object
 */
function validateIBAN(iban) {
	var newIban = iban.toUpperCase();
	if(!newIban.startsWith('DE')) {
		return false;
	}
	var mod97 = function(digit_string) {
		var m = 0;
		for (var i = 0; i < digit_string.length; ++i)
			m = (m * 10 + parseInt(digit_string.charAt(i))) % 97;
		return m;
	};

	if (newIban.search(/^[A-Z]{2}/gi) < 0) {
		return false;
	}

	newIban = newIban.substring(4) + newIban.substring(0, 4);

	newIban = newIban.replace(/[A-Z]/g, function (match) {
		return match.charCodeAt(0) - 55;
	});

	return parseInt(mod97(newIban)) === 1;
}


var DonationForm = function(formSelector, rules, messages, sternstundenTag) {
	this.initialize(formSelector, rules, messages, sternstundenTag);
};

DonationForm.prototype = {
	/*
	 * Initialize form, set up validation etc.
	 * @param string jQuery selector for form
	 * @param object rules Object with validation rules for all fields
	 * @param object messages Object with validation messages for all fields
	 * @param boolean sternstundenTag Set true on Sternstunden Tag (has effect on required fields and validation)
	 */
	initialize: function(formSelector, rules, messages, sternstundenTag) {
		this.$form = $(formSelector);
		this.sternstundenTag = sternstundenTag;
		this.rules = rules;
		this.messages = messages;
		this.currentStep = 0;
		this.addressRequired = false;
		this.companyRequired = false;
		this.debitRequired = false;

		$.validator.addMethod('number', function(value, element) {
			return this.optional(element)
					|| (/^(\d+)([.,]\d{1,2})?$/.test(value) && value.replace(/,/, '.') >= 1);
			}, 'Bitte geben Sie den Spendenbetrag ein!');
		$.validator.addMethod('iban', function(value, element) {
			var number = value.replace(/\s/g,'');
			return this.optional(element) || (
					validateIBAN(number) &&
							value != $(element).data('invalid')
					);
		}, 'Bitte geben Sie eine gültige deutsche IBAN ein!');

		this.updateValidationForm();
	},


	setDebitRequired: function (required) {
		$('.form-input.iban .optional').remove();
		if (required) {
			this.debitRequired = true;
			$('#iban').attr('required', 'true');
			$('.form-input.iban').show();
		} else {
			this.debitRequired = false;
			$('.form-input.iban label.error').each(function() {
				var el = $(this).attr('for');
				$('#error-list-' + el).remove();
				$(this).remove();
			});
			$('.form-input.iban label').append('<span class="optional"> (optional)</span>');
			$('.form-input.iban').hide();
		}
	},

	setCreditCardRequired: function (required) {
		if (required) {
			$('.creditCardInfo').show();
		} else {
			$('.creditCardInfo').hide();
		}
	},

	/*
	 * Set or unset company field required for validation
	 * On SternstundenTag when the company field is set to required
	 * firstname and name are requiredt too, otherwise not.
	 * @param boolean required If true, address fields are set required; if false, they are not required
	 */
	setCompanyRequired: function (required) {
		if (required) {
			this.companyRequired = true;
			$('.genderFields .optional').remove();
			$('#company').attr('required', 'true');
			$('.form-input.company').show();
		} else {
			this.companyRequired = false;
			$('.form-input.company label.error').each(function() {
				var el = $(this).attr('for');
				$('#error-list-' + el).remove();
				$(this).remove();
			});
			$('#company').attr('required', 'false');
			$('.form-input.company').hide();
		}
	},


	/*
	 * Update address validation rules depending on amount and sternstundenTag
	 */
	updateValidationForm: function() {
		if ($('input[name=frequency]:checked', '#donation-form').val() > 0) {
			$('#payment-methods-periodic').show();
			$('#payment-methods-one-time').hide();
			$('#paymentmethoddirectdebit').attr('checked', 'checked');
			$('.paymentmethodcreditcard').hide();
		} else {
			$('#payment-methods-periodic').hide();
			$('#payment-methods-one-time').show();
			$('.paymentmethodcreditcard').show();
		}
		if ($('#genderc:checked').val() == 'c') {
			this.setCompanyRequired(true);
		} else {
			this.setCompanyRequired(false);
		}
		if ($('#paymentmethoddirectdebit:checked').val() == 'directdebit') {
			this.setDebitRequired(true);
		} else {
			this.setDebitRequired(false);
		}
		if ($('#paymentmethodcreditcard:checked').val() == 'creditcard') {
			this.setCreditCardRequired(true);
		} else {
			this.setCreditCardRequired(false);
		}
	},

	/*
	 * Get current step
	 * @return int number of current step
	 */
	getCurrentStep: function() {
		return $('#donation-progressbar ul li.active').index('li');
	},

	/*
	 * Validation callbacks
	 */
	validationHandler: {
		submit: function(form) {
			if (donationForm.getCurrentStep() < 2) {
				$.address.value('step-' + (donationForm.getCurrentStep() + 1));
				window.showDonationStep(donationForm.getCurrentStep() + 1);
			} else {
				form.submit();
			}
		},
	},
};
window.DonationForm = DonationForm;

window.errorPlacement = function(error, element){
	error.appendTo( element.parent() );
	if (element.attr('type') == 'radio') {
		error.appendTo( element.parent().parent() );
	} else {
		error.appendTo( element.parent() );
	}
	element.closest('.form-radio-set, .form-input, .form-check').addClass('error');
};

window.invalidHandler = function(form, validator) {
	var errorList = '';
	for ( var i = 0; validator.errorList[i]; i++ ) {
		var error = validator.errorList[i];
		errorList += '<li><a id="error-list-' + error.element.name + '" class="link" tabindex="0" href="javascript:focusFormElement(\'' + error.element.id + '\', \'error-list-' + error.element.name + '\')">' + error.message + '</a></li>';
	}
	$('#donation-form-errors').html('<div class="donation-form-errors-inner"><div class="block"><div class="content"><h2>Korrigieren Sie folgende Fehler, um zum nächsten Schritt zu gelangen:</h2><ul>' + errorList + '</ul></div></div></div>');
	$(':input', '#donation-form').blur(errorContainerUpdate);
	$('input, textarea', '#donation-form').keyup(errorContainerUpdate);
	$('select', '#donation-form').change(errorContainerUpdate);
	$('input:radio,input:checkbox', '#donation-form').click(errorContainerUpdate);
	$('#donation-form-errors h2').moveFocus();
};

var errorContainerUpdate = function(){
	$(this).valid(); // Validates the active field
	var cont = $(this).closest('.form-radio-set, .form-input, .form-check');
	var haserror = $('label.error:visible', cont).size();
	if (haserror < 1) {
		var listEl = $('#error-list-' + $(this).attr('name'));
		if (listEl.find('strike').size() == 0) {
			listEl.removeClass('link');
			listEl.addClass('link-passed');
			listEl.attr('tabindex','-1');
			listEl.wrapInner('<strike />');
		}
		cont.removeClass('error');
		$(this).attr('aria-invalid','false');
	} else {
		var wrapped = $('#error-list-' + $(this).attr('name') + ' strike');
		wrapped.replaceWith(wrapped.html());
		cont.addClass('error');
		$('#error-list-' + $(this).attr('name')).removeClass('link-passed');
		$('#error-list-' + $(this).attr('name')).addClass('link');
		$('#error-list-' + $(this).attr('name')).attr('tabindex','0');
		$(this).attr('aria-invalid','true');
	}
};


/* eslint-disable-next-line no-unused-vars */
window.checkAmount = function() {
	if (donationForm.sternstundenTag) {
		if (parseFloat($('#amount').val().replace(/,/, '.')) > 300) {
			$('#donationreceipt').attr('disabled',false)[0].checked = true;
		} else {
			$('#donationreceipt').attr('disabled',true)[0].checked = false;
		}
		donationForm.updateValidationForm();
	}
};

/*
 * update progressBar
 * @param int stepId Number of current step (0-3)
 */
function updateProgessbar(stepId){
	$('#donation-progressbar ul li').removeClass('active').removeClass('passed');

	$('#donation-progressbar ul li:lt(' + stepId + ')').addClass('passed');
	$('#donation-progressbar ul li:eq(' + stepId + ')').addClass('active');

	// strip off the links
	$('#donation-progressbar ul li a').each(function() {
		$(this).replaceWith($(this).html());
	});

	for (var i = 0; i < stepId; i++) {
		$('#donation-progressbar ul li:eq(' + i + ')').wrapInner('<a href="#step-' + i + '" />');
	}
}

/*
 * Switch DonatationStep
 * @param int stepId Number of step to show (0-3)
 */
window.showDonationStep = function(stepId) {
	window.checkAmount();
	$('#donation-form-errors').html('');
	$('.form-radio-set, .form-input, .form-check').removeClass('error');

	$(':input', '#donation-form').unbind();
	$('input, textarea', '#donation-form').unbind();
	$('select', '#donation-form').unbind();
	$('input:radio,input:checkbox', '#donation-form').unbind();

	$('.donation-step').hide();
	$('#step-' + stepId + '-div').show();

	$('#step-title').html($('#donation-progressbar .step-' + stepId + ' .text').html());

	$('#step-title').moveFocus();

	$('html').scrollTop(0);

	updateProgessbar(stepId);

	donationForm.updateValidationForm();
};
